// 会话历史：纯本地存储（localStorage），不经过后端、不跨设备同步。
// 按 user_id 分区，避免同一台电脑多人登录时历史互相串。

import { ChatMessage } from "../components/MessageBubble";

export interface StoredConversation {
  threadId: string;
  title: string;
  env: string;
  awaitingClarification: boolean;
  updatedAt: number;
  messages: ChatMessage[];
}

const KEY_PREFIX = "sql-agent:conversations:";
const MAX_CONVERSATIONS = 50; // 软上限，防止 localStorage 无限增长

function storageKey(userId: string): string {
  return `${KEY_PREFIX}${userId}`;
}

function readAll(userId: string): StoredConversation[] {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(userId: string, conversations: StoredConversation[]): void {
  localStorage.setItem(storageKey(userId), JSON.stringify(conversations));
}

export function listConversations(userId: string): StoredConversation[] {
  return readAll(userId).sort((a, b) => b.updatedAt - a.updatedAt);
}

export function getConversation(
  userId: string,
  threadId: string,
): StoredConversation | undefined {
  return readAll(userId).find((c) => c.threadId === threadId);
}

export function saveConversation(userId: string, conv: StoredConversation): void {
  const all = readAll(userId);
  const idx = all.findIndex((c) => c.threadId === conv.threadId);
  if (idx >= 0) all[idx] = conv;
  else all.push(conv);

  all.sort((a, b) => b.updatedAt - a.updatedAt);
  writeAll(userId, all.slice(0, MAX_CONVERSATIONS));
}

export function deleteConversation(userId: string, threadId: string): void {
  writeAll(userId, readAll(userId).filter((c) => c.threadId !== threadId));
}

export function deriveTitle(messages: ChatMessage[]): string {
  const firstUser = messages.find((m) => m.role === "user");
  if (!firstUser) return "新对话";
  const text = firstUser.content.trim().replace(/\s+/g, " ");
  if (!text) return "新对话";
  return text.length > 24 ? `${text.slice(0, 24)}…` : text;
}
